module.exports = __webpack_public_path__ + "static/media/not_found.a1d6405a.jpg";